export default {
    methods: {
        checkUserName(firstName, lastName, id = null) {
            let name

            if (firstName) name = firstName
            if (firstName && lastName) name += " " + lastName
            if (!firstName && lastName) name = lastName

            if (name) return name
            if (!name && id) return `${this.t("expert.contact")} ${id}`
            return this.t("expert.usermenu.anonyme_fish")
        }
    }
}
